import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";

import IconButton from "@material-ui/core/IconButton";

import { DataGrid } from "@material-ui/data-grid";
import { makeStyles } from "@material-ui/core";

const userStateDictionary = [
  { key: 0, value: "Unknown" },
  { key: 1, value: "Confirmed" },
  { key: 2, value: "Unconfirmed" },
];
const userStateTranslator = (state) => {
  return userStateDictionary.find((element) => element.key === state).value;
};

const renderCustomChip = (state) => {
  const color = state === 1 ? "primary" : "secondary";
  return (
    <Chip
      color={color}
      size="small"
      label={userStateTranslator(state)}
    />
  );
};

const columns = [
  {
    field: "login",
    headerName: "Login",
    width: 150,
  },
  {
    field: "email",
    headerName: "Email",
    width: 150,
  },
  { field: "role", headerName: "Role", width: 150 },
  {
    field: "isActive",
    headerName: "Active?",
    width: 150,
    type: "boolean",
  },
  {
    field: "state",
    headerName: "State",
    renderCell: (params) => renderCustomChip(params.value),
    width: 150,
  },
];

const useStyles = makeStyles((theme) => ({
  titleMargin: {
    margin: theme.spacing(1, 0, 4, 0),
  },
  grid: {
    background: "white",
  },
}));

const UsersList = (props) => {
  const classes = useStyles();

  return (
    <>
      <Typography gutterBottom variant="h5" className={classes.titleMargin}>
        Users
      </Typography>
      <div style={{ height: 350 }}>
        <DataGrid
          className={classes.grid}
          rows={props.users}
          loading={props.isLoading}
          columns={columns}
          density={props.density}
          onRowSelected={props.onRowSelected}
        />
      </div>
      <Grid container direction="row" justify="flex-end" alignItems="center">
        <IconButton
          aria-label="add"
          color="primary"
          onClick={props.onAdd}
          disabled={props.isAddDisabled}
        >
          <AddIcon />
        </IconButton>
        <IconButton
          aria-label="edit"
          color="primary"
          disabled={props.isEditDisabled}
          onClick={props.onEdit}
        >
          <EditIcon />
        </IconButton>

        <IconButton
          aria-label="delete"
          color="secondary"
          disabled={props.isDeleteDisabled}
          onClick={props.onDelete}
        >
          <DeleteIcon />
        </IconButton>
      </Grid>
    </>
  );
};

export default UsersList;
